import { render, staticRenderFns } from "./TranshipmentEvaluationsView.vue?vue&type=template&id=64425f04&scoped=true"
import script from "./TranshipmentEvaluationsView.vue?vue&type=script&lang=js"
export * from "./TranshipmentEvaluationsView.vue?vue&type=script&lang=js"
import style0 from "./TranshipmentEvaluationsView.vue?vue&type=style&index=0&id=64425f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64425f04",
  null
  
)

export default component.exports